import React from 'react'
import { Apple, Sparkles } from 'lucide-react';
import { AiOutlineApple } from "react-icons/ai";
import us_dark from '../../assets/video/vid_en_dark.mp4'

const Hero = () => {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/80 to-black/90" />

      <div className="absolute inset-0 opacity-30">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 rounded-full filter blur-[120px] animate-pulse" style={{ backgroundColor: '#1abc9c' }} />
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-cyan-500 rounded-full filter blur-[120px] animate-pulse delay-1000" />
      </div>

      <div className="absolute inset-0">
        {[...Array(20)].map((_, i) => (
          <div
            key={i}
            className="absolute w-px h-px bg-white rounded-full animate-pulse"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 3}s`,
              opacity: Math.random() * 0.5 + 0.2,
            }}
          />
        ))}
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 w-full">
        <div className="grid lg:grid-cols-2 gap-12 items-center min-h-screen py-20">
          <div className="text-left animate-fade-in-up">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full glass-effect mb-8 mt-5">
              <Sparkles className="w-4 h-4" style={{ color: '#1abc9c' }} />
              <span className="text-sm text-white/70">
                Introducing SnapBill
              </span>
            </div>

            <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
              {/* <HeaderText text={`Your Invoices`} text2={`Reinvented.`} /> */}
              Your Invoices.
              <br />
              <span className="gradient-text">Reinvented.</span>
            </h1>

            <p className="text-2xl md:text-3xl text-white/90 mb-8 font-medium">
              {/* Create your invoice in less than 20 seconds. */}
              SnapBill makes it fast, beautiful, and effortless — in less than 20 seconds.
            </p>

            <p className="text-lg text-white/60 mb-10 max-w-xl leading-relaxed">
              From auto-filled client details to elegant, brandable templates — SnapBill makes every invoice fast, flawless, and beautifully professional.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              {/* <button
                className="group relative px-10 py-5 text-white rounded-2xl font-semibold text-lg transition-all duration-300 transform hover:scale-105 flex items-center justify-center gap-3 overflow-hidden shadow-[0_20px_60px_rgba(26,188,156,0.4)] hover:shadow-[0_30px_80px_rgba(26,188,156,0.6)]"
                style={{ backgroundColor: '#1abc9c' }}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#16a085'}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#1abc9c'}
              >
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-700" />
                <Apple className="w-6 h-6 relative z-10" />
                <span className="relative z-10">Download on App Store</span>
              </button> */}
              {/* <button className="px-8 py-4 glass-effect text-white rounded-2xl font-semibold hover:bg-white/10 transition-all duration-300 transform hover:scale-105">
                Watch Demo
              </button> */}
              <button className="group px-14 py-5 glass-effect text-white rounded-2xl font-semibold text-lg hover:bg-white/15 transition-all duration-300 transform hover:scale-105 border-2 border-white/20 hover:border-white/30 flex justify-center items-center gap-3"
                onClick={()=>{
                  window.open('https://apps.apple.com/us/app/invoice-template-snapbill/id6753898367', '_blank');
                }}
              >
                <AiOutlineApple size={24} style={{marginBottom:2}} />
                <span className="relative z-10">Download on App Store</span>
              </button>
            </div>
          </div>

          <div className="h-[90vh] relative animate-fade-in-up delay-200 flex justify-center lg:justify-end">
            <div className="relative scale-75 md:scale-[0.6] h-[20vh]">
              <div className="absolute inset-0 bg-gradient-to-t from-transparent to-transparent blur-3xl" style={{ background: 'linear-gradient(to top, transparent, rgba(26, 188, 156, 0.2), transparent)' }} />
              <div className="relative glass-card rounded-[3rem] p-6 transform animate-float">
                <div className="bg-gradient-to-br from-gray-900 to-black rounded-[2.5rem] p-3 shadow-2xl">
                  <div className="relative aspect-[9/19.5] bg-black rounded-[2rem] overflow-hidden">
                    <video
                      className="w-full h-full object-cover"
                      autoPlay
                      loop
                      muted
                      playsInline
                    >
                      <source src={us_dark} type="video/mp4" />
                    </video>
                    <div className="absolute top-0 left-1/2 -translate-x-1/2 w-32 h-7 bg-black rounded-b-3xl" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Hero